import { InfoOutlined } from '@mui/icons-material';
import { DialogContent, Divider, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SanitizeHTML } from '~/components/SanitizeHTML';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useCompanyInformationDialog } from '~/features/CompanyInformationDialog/useCompanyInformationDialog';

type PropsType = {
  open: boolean;
  onClose: () => void;
};

export const CompanyInformationDialog = (props: PropsType) => {
  const { open, onClose } = props;
  const { t } = useTranslation();

  const { message, messageDate } = useCompanyInformationDialog();

  const sanitizedCompanyMessage = message ? (
    <SanitizeHTML html={message} />
  ) : undefined;

  return (
    <DraggableDialog open={open} onClose={onClose} fullWidth={true}>
      <SolaForceDialogTitle onClose={onClose} icon={<InfoOutlined />}>
        {t('laCompInfo')}
      </SolaForceDialogTitle>
      <Divider />
      <DialogContent>
        {messageDate && (
          <Typography variant={'caption'}>
            {moment(messageDate).format('LLLL')}
          </Typography>
        )}
        {sanitizedCompanyMessage}
      </DialogContent>
    </DraggableDialog>
  );
};
